// extracted by mini-css-extract-plugin
export default {"label":"styles_label__zVSAD","checkbox_container":"styles_checkbox_container__1h+TL","checkbox":"styles_checkbox__CFPKL","icon":"styles_icon__MMqDb"};